<template>
	<div>
		<div class="pageFrom  animate__animated  ">
			
			<div class="sec-title">
				<el-image :src="require('@/static/CodeBuddyAssets/31270_3509/24.svg')"></el-image>
				<span>{{$t('point.t1')}}</span>
			</div>
			
			<div class="shaixuanFrom f-bct">
				<div class="iptBox">
					<el-image :src="require('@/static/sel/6.svg')"></el-image>
					<el-input v-model="consignee" :placeholder="$t('point.t2')"></el-input>
				</div>
				<div class="iptBox">
					<el-image :src="require('@/static/sel/6.svg')"></el-image>
					<el-input v-model="mobile" :placeholder="$t('point.t3')"></el-input>
				</div>
				<div class="iptBox">
					<el-image :src="require('@/static/sel/6.svg')"></el-image>
					<el-input v-model="address" :placeholder="$t('point.t4')"></el-input>
				</div>
				<div class="action-bar1">
					<el-button type="primary" class="submit-btn" @click="warehouselist">{{$t('point.t5')}}</el-button>
				</div>
			</div>
			
			<div class="cangList f-bct">
				<div class="info-card" v-for="(item,index) in cangMsg">
					<el-image class="card-icon" :src="require('@/static/CodeBuddyAssets/31270_3509/22.svg')"></el-image>
					<div class="card-body">
						<div class="card-name f-bct">
							<div class="name">
								<span class="t1">{{item.name}}</span>
								<span class="t2">{{$t('point.t6')}}：{{item.postcode}}</span>
							</div>
							<div class="copy f-ct" @click="copyBox(item)">
								<el-image :src="require('@/static/sel/7.svg')"></el-image>
								<span>{{$t('point.t7')}}</span>
							</div>
						</div>
						<div class="card-contact">
							<span>{{item.consignee}}</span>
							<span>{{item.mobile}}</span>
						</div>
						<div class="card-addr">{{item.province}}{{item.city}}{{item.address}}</div>
					</div>
				</div>
			</div>
			
		</div>
	</div>
</template>
<script>
import { warehouselist } from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			consignee:'',
			mobile:'',
			address:'',
			cangMsg:[],
			selIdx:0,
		}
	},
	mounted() {
		this.warehouselist()
	},
	methods:{
		copyBox(item){
			var cangMsg = item
			var str = cangMsg.name+cangMsg.consignee+cangMsg.mobile+cangMsg.province+cangMsg.city+cangMsg.address
			this.copy_txt(str)
		},
		// 仓库列表(全部正常的)
		async warehouselist(){
			var data = {}
			if(this.consignee){
				data.consignee = this.consignee
			}
			if(this.mobile){
				data.mobile = this.mobile
			}
			if(this.address){
				data.address = this.address
			}
			const res = await warehouselist(data)
			if(res.code==200){
				this.cangMsg = res.rows
			}else{this.Tips(res.msg,'error')}
		},
	},
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
/* ========== 设计令牌 ========== */
$primary: #0096FF;
$danger: #FC2933;
$text-dark: #333333;
$text-gray: #999999;
$text-muted: #C6C6C6;
$border-color: #D9D9D9;
$page-bg: #F8F8F8;
$card-bg: #FFFFFF;
$cargo-bg: #FAFCFE;
$info-bg: #FAFAFA;
$thumb-bg: #E7F6FF;
$radius-sm: 0.04rem;
$radius-md: 0.08rem;
$radius-lg: 0.12rem;

$font-lg: 0.20rem;
$font-md: 0.16rem;
$font-sm: 0.14rem;
$font-xs: 0.13rem;

$input-height: 0.50rem;
$gap-section: 0.32rem;
$gap-form: 24px;
$gap-upload: 0.14rem;
$sel-gap: 24px; // 选项间距	

/* ========== 通用区块标题 ========== */
.sec-title {
	display: flex;
	align-items: center;
	margin-bottom: 0.16rem;

	.el-image {
		width: 0.02rem;
		height: 0.20rem;
		margin-right: 0.08rem;
		// flex-shrink: 0;
		display: block;
	}

	span {
		font-size: $font-lg;
		font-weight: 500;
		color: $text-dark;
	}
}
.pageFrom{
	width: 100%;
	background: #fff;
	border-radius: 10px;
	padding: 24px 32px;
	margin-top: 24px;
	padding-bottom: 40px;
	
}
/* ========== 操作按钮区 ========== */
.action-bar {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 0.30rem;
	padding-top: 0.24rem;
	.submit-btn {
		width: 1.84rem;
		height: 0.60rem;
		border-radius: 0.10rem;
		font-size: 0.18rem;
		font-weight: 500;
		transition: opacity 0.25s ease, transform 0.15s ease;
	
		&:hover {
			opacity: 0.90;
			transform: translateY(-0.01rem);
		}
	
		&:active {
			transform: translateY(0);
			opacity: 1;
		}
	}
}
.action-bar1 {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	.submit-btn {
		width: 1.16rem;
		height: 0.46rem;
		border-radius: 0.10rem;
		font-size: 0.18rem;
		font-weight: 500;
		transition: opacity 0.25s ease, transform 0.15s ease;
	
		&:hover {
			opacity: 0.90;
			transform: translateY(-0.01rem);
		}
	
		&:active {
			transform: translateY(0);
			opacity: 1;
		}
	}
}

/* ========== 信息卡片 ========== */
.cangList{
	
}

.info-card {
	width: 758px;
	background: #f9f9f9;
	cursor: pointer;
	border-radius: 12px;
	padding: 24px 32px;
	box-sizing: border-box;
	display: flex;
	align-items: flex-start;
	margin-top: 0.16rem;
	transition:  0.25s ;

	.card-icon {
		width: 0.20rem;
		height: 0.20rem;
		flex-shrink: 0;
		margin-right: 0.12rem;
		margin-top: 0.02rem;
	}

	.card-body {
		flex: 1;
		min-width: 0;
	}

	.card-name {
		font-size: $font-md;
		font-weight: 500;
		color: $text-dark;
		margin-bottom: 0.12rem;
		display: flex;
		align-items: center;
		.name{
			.t1{
				color: #333333;
				font-weight: bold;
			}
			.t2{
				color: #999999;
				padding-left: 8px;
			}
		}
		.copy{
			span{
				font-size: 14px;
				color: #0096FF;
			}
			::v-deep .el-image{
				width: 15px;
				margin-right: 6px;
			}
		}
		.card-phone {
			margin-left: 0.20rem;
			font-weight: 400;
		}
	}

	.card-contact {
		font-size: $font-sm;
		color: $text-dark;
		margin-bottom: 0.08rem;

		span + span {
			margin-left: 0.16rem;
		}
	}

	.card-sub {
		font-size: $font-sm;
		color: $text-dark;
		margin-bottom: 0.06rem;
	}

	.card-addr {
		font-size: $font-sm;
		color: $text-gray;
		word-break: break-all;

		.addr-blue {
			color: $primary;
			margin-right: 0.06rem;
		}

		.addr-gray {
			color: $text-gray;
		}
	}
}
.info-card-a{
	transition:  0.25s ;
	span,div{
		color: #fff!important;
	}
	background: #0096FF;
}
.shaixuanFrom{
	margin-bottom: 12px;
	.iptBox{
		width: 445px;
		height: 50px;
		border-radius: 8px;
		background: #F9F9F9;
		padding: 0 20px;
		display: flex;
		align-items: center;
		::v-deep .el-input {
			width: 400px;
			height: 100%;
			border: none;
			padding-left: 16px;
		}
		::v-deep .el-input__inner {
			text-align: left;
			width: 100%;
			height: 100%;
			line-height: 0.78rem;
			background: transparent;
			border: none;
			font-size: 16px;
			padding: 0;
			&::placeholder {
				color: #A8A8A8;
			}
			&:focus {
				border-color: transparent;
				box-shadow: none;
			}
		}
	}
}
</style>